<template>
  <div class="weiVCon">
    <div
      class="weiViewoBox"
      v-show="isHasdata"
    >
      <div class="weiVItems">
        <ul class="clearfix">
          <li
            class="fl"
            v-for="item in micVideolist"
            :key="item.index"
          >
            <!-- vType:0--不记时视频 1--要计时视频 -->
            <router-link :to="{path:'/videoD',query:{vObj:JSON.stringify(item),vType:0}}">
              <div class="weiVImgBox">
                <img
                  :src="item.imagePath"
                  alt=""
                  class="weiVImg"
                  :onerror="defaultImg"
                />
                <img
                  src="../assets/imgs/playIcon.png"
                  alt=""
                  class="toPlay"
                />
                <span>{{item.dataduration}}</span>
              </div>
              <p class="videoTit">{{item.title}}</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-show="!isHasdata"
      class="noData"
    >
      <img
        src="../assets/imgs/noDataIcon.png"
        alt=""
      >
      <p class="noDataTit">未查询到相关数据</p>
      <p>暂无数据，请刷新重试</p>
    </div>
  </div>
</template>

<script>
import { getAqxxVideo } from '../../src/api/Api'
export default {
  name: 'weiVCon',
  data () {
    return {
      micVideolist: [], // 列表
      defaultImg: 'this.src="' + require('../assets/imgs/banner.png') + '"', // 默认图地址
      isHasdata: true
    }
  },
  created () {
    this.getAqxxVideo()
  },
  mounted () {
    window.myVue = this
  },
  methods: {
    getAqxxVideo () {
      var _this = this
      getAqxxVideo({
        type: 1
      }).then(res => {
        if (res.data.returnCode === 1) {
          this.isHasdata = true
          _this.micVideolist = res.data.returnDate
          if (res.data.returnDate.length < 1) {
            this.isHasdata = false
          }
        } else {
          this.isHasdata = false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SafeStudy.vue